export const downloadFile = (fileUrl: string): void => {
  const link = document.createElement("a");
  link.href = fileUrl;
  document.body.append(link);
  link.click();
  document.body.removeChild(link);
};
